<app-content>
  <app-breadcrumbs>
    <li>
      Płatności online
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Płatności online
    </h2>
    <form novalidate [formGroup]='form' (ngSubmit)='submit()' autocomplete='off'>
      <fieldset>
        <legend>
          Wybierz rodzaj usługi
        </legend>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"paymentCategory" as controlName'>
              <label [for]='controlName'>
                Rodzaj sprawy *
              </label>
              <select
                (ngModelChange)='form.paymentCategoryChange($event)'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option [value]='item?.id' *ngFor='let item of form.paymentCategories()'>
                  {{ item.name }}
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Wybierz tytuł płatności
        </legend>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"paymentPosition" as controlName'>
              <label [for]='controlName'>
                Tytuł płatności *
              </label>
              <select
                (ngModelChange)='form.paymentPositionChange($event)'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option [value]='item?.id' *ngFor='let item of form.paymentPositions()'>
                  {{ item.name }}
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div *ngIf='form.multiple()' class='col-md-6 d-flex align-items-center'
               style='padding-bottom: 1.25rem; padding-top: 1.5rem'>
            <button type='button' title='Więcej' class='btn btn-secondary icon-btn'
                    (click)='form.count = (form.count + 1); form.updateTotalAmount()'>
              <i class='fa fa-plus' aria-hidden='true'></i>
            </button>
            &nbsp;
            <button type='button' title='Mniej' class='btn btn-secondary icon-btn'
                    (click)='form.count > 1 ? form.count = (form.count - 1) : null; form.updateTotalAmount()'>
              <i class='fa fa-minus' aria-hidden='true'></i>
            </button>
            &nbsp;
            <app-label label='Ilość:'>
              {{ form.count }}
            </app-label>
          </div>
          <div class='col-12' *ngIf='form.hasDescription()'>
            <div class='form-group' *ngIf='"clientDescription" as controlName'>
              <label [for]='controlName'>
                Opis
              </label>
              <textarea
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Opis (max 50 znaków)'></textarea>
              <app-validation-errors [showTextLength]="true" [maxTextLength]="50" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <div class='d-flex justify-content-end'>
        <app-label
          label='Wysokośc wybranej opłaty:'>{{ (form.selectedAmount * form.count).toFixed(2).replace('.', ',') }} PLN
        </app-label>
      </div>
      <hr>
      <br>
      <div class='form-actions top' *ngIf='authed'>
        <button type='button' class='btn btn-secondary' (click)='onPastDataFromLoginGov()'>
          <i class='fa fa-paste' aria-hidden='true'></i>
          Wczytaj dane z Profilu zaufanego
        </button>
        <button type='button' class='btn btn-secondary' (click)='onPastDataFromPortal()'>
          <i class='fa fa-paste' aria-hidden='true'></i>
          Wczytaj dane z Portalu e-usług
        </button>
      </div>
      <fieldset>
        <legend>
          Podaj swoje dane
        </legend>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"entityType" as controlName'>
              <label [for]='controlName'>
                Typ podmiotu *
              </label>
              <select
                (ngModelChange)='form.entityTypeChange($event)'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option [value]='item.key' *ngFor='let item of form.entityTypes'>
                  {{ item.value }}
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <div class='row'>
          <ng-container *ngIf='form.get("entityType")?.value === "2"'>
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"clientName" as controlName'>
                <label [for]='controlName'>
                  Nazwa instytucji *
                </label>
                <input
                  [id]='controlName'
                  [formControlName]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  placeholder='Wpisz tu nazwę instytucji'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"nip" as controlName'>
                <label [for]='controlName'>
                  NIP *
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu NIP'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf='form.get("entityType")?.value === "1"'>
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"clientFirstName" as controlName'>
                <label [for]='controlName'>
                  Imię *
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu imię/imiona'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"clientLastName" as controlName'>
                <label [for]='controlName'>
                  Nazwisko *
                </label>
                <input
                  [id]='controlName'
                  [formControlName]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  placeholder='Wpisz tu nazwisko'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </ng-container>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"clientEmail" as controlName'>
              <label [for]='controlName'>
                E-mail *
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu e-mail'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"town" as controlName'>
              <label [for]='controlName'>
                Miejscowość *
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu miejscowość'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"street" as controlName'>
              <label [for]='controlName'>
                Ulica *
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu nazwę ulicy'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"streetNumber" as controlName'>
              <label [for]='controlName'>
                Nr. budynku / lokalu *
              </label>
              <input
                [id]='controlName'
                [formControlName]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                placeholder='Wpisz tu nr. budynku / lokalu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <div class='form-actions'>
        <a routerLink='../' class='btn btn-secondary'>
          Anuluj
        </a>
        <button type='submit' class='btn btn-primary'>
          Dokonaj płatności
        </button>
      </div>
    </form>
  </section>
</app-content>
